module.exports = __webpack_public_path__ + "static/media/button-green.6f722905.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/button-green.svg
// module id = 2873
// module chunks = 0